import { i18next } from '@yola/ws-sdk';

const generateFolderName = (folders, locale) => {
  const untitledCaption = i18next.t('Untitled');
  const folderNames = folders
    .filter((folder) => folder.locale === locale)
    .map((folder) => folder.name?.trim().toLowerCase());

  const getUniqueFolderName = (folderIndex = 1) => {
    const folderName = `${untitledCaption}-${folderIndex}`;

    if (!folderNames.includes(folderName.toLowerCase())) {
      return folderName;
    }

    return getUniqueFolderName(folderIndex + 1);
  };

  return getUniqueFolderName();
};

export default generateFolderName;
